import React from "react";
import { Marker, Pane } from "react-leaflet";
import { drawnMapPoiMarker } from "./MapPoiDrawing";
import { connect } from "react-redux";

class MapPoiDrawingMovement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Pane>
        {this.props.currentCursorCoords && this.props.displayMapPoiCursor && (
          <Marker
            icon={drawnMapPoiMarker}
            position={this.props.currentCursorCoords}
            zIndex={1}
            zIndexOffset={1}
          />
        )}
      </Pane>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCursorCoords: state.map.currentCursorCoords,
    displayMapPoiCursor: state.map.displayMapPoiCursor,
  };
};

export default connect(mapStateToProps, null)(MapPoiDrawingMovement);
